import Config from '../config'
import { defineStore } from 'pinia'
import { FetchWrapper } from '@/lib'

export const useVersionStore = defineStore('versionStore', {
    state: () => ({
        version: null
    }),
    actions: {
        async getVersion() {
            var self = this

            if (this.version) {
                return this.version
            }

            const baseUrl = new URL(Config.BASE_URL);
            const versionUrl = baseUrl.origin + '/version'

            return await FetchWrapper.get(versionUrl)
            .then((result) => {
                if (result && result.version) {
                    self.version = result.version
                }
                return self.version
            }).catch((error) => {
                return Promise.reject(error)
            })
        }
    }
})
